import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import DualCtaSection from './components/DualCtaSection';
import CategoryGridSection from './components/CategoryGridSection';
import ComparisonSection from './components/ComparisonSection';
import VisualCtaSection from './components/VisualCtaSection';
import BlogSection from './components/BlogSection';
import TrustSection from './components/TrustSection';

const jsonLd = {
  '@type': 'WebSite',
  name: 'Mulebuy Spreadsheet Hub',
  url: '/',
  description: 'Find trusted mulebuy spreadsheet lists, compare verified agents, and access the most updated buying data in one place.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: '/?s={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SEO
        title="Best Mulebuy Spreadsheet Hub &amp; Updated Buying Directory"
        description="Find trusted mulebuy spreadsheet lists, compare agents, and access the most updated buying data for shoes, hoodies, t-shirts, jackets and more. The ultimate mulebuy spreadsheet directory updated weekly with verified sources."
        keywords="mulebuy spreadsheet, mulebuy spreadsheets, spreadsheet buying guide, china buying spreadsheet, agent spreadsheet comparison"
        canonicalPath="/"
        jsonLd={jsonLd}
      />
      <Header />
      <main>
        <HeroSection />
        <DualCtaSection />
        <CategoryGridSection />
        <ComparisonSection />
        <VisualCtaSection />
        <BlogSection />
        <TrustSection />
      </main>
      <Footer />
    </>
  );
}